import React, { createContext, useState, useCallback } from 'react';

export const CarritoContext = createContext();

export const CarritoProvider = ({ children }) => {
  const [productosCarrito, setProductosCarrito] = useState([]);
  const [tipoEntrega, setTipoEntrega] = useState('retiro'); // 'retiro' o 'envio'

  // Agregar producto al carrito
  const agregarProducto = useCallback((mueble) => {
    setProductosCarrito(prev => {
      const existe = prev.find(item => item._id === mueble._id);
      if (existe) {
        // Si ya existe, aumentar cantidad
        return prev.map(item =>
          item._id === mueble._id
            ? { ...item, cantidad: item.cantidad + 1 }
            : item
        );
      }
      // Si no existe, agregar con cantidad 1
      return [...prev, { ...mueble, cantidad: 1 }];
    });
  }, []);

  // Eliminar producto del carrito
  const eliminarProducto = useCallback((muebleId) => {
    setProductosCarrito(prev => prev.filter(item => item._id !== muebleId));
  }, []);

  // Cambiar cantidad de un producto
  const cambiarCantidad = useCallback((muebleId, cantidad) => {
    if (cantidad <= 0) {
      eliminarProducto(muebleId);
      return;
    }
    setProductosCarrito(prev =>
      prev.map(item =>
        item._id === muebleId
          ? { ...item, cantidad }
          : item
      )
    );
  }, []);

  // Cambiar tipo de entrega
  const cambiarTipoEntrega = useCallback((tipo) => {
    setTipoEntrega(tipo);
  }, []);

  // Limpiar carrito
  const limpiarCarrito = useCallback(() => {
    setProductosCarrito([]);
  }, []);

  // Calcular subtotal
  const calcularSubtotal = useCallback(() => {
    return productosCarrito.reduce((total, item) => total + (item.precio * item.cantidad), 0);
  }, [productosCarrito]);

  // Calcular costo de envío (simulado: $5000 si es envío)
  const calcularCostoEnvio = useCallback(() => {
    return tipoEntrega === 'envio' ? 5000 : 0;
  }, [tipoEntrega]);

  // Calcular total
  const calcularTotal = useCallback(() => {
    return calcularSubtotal() + calcularCostoEnvio();
  }, [calcularSubtotal, calcularCostoEnvio]);

  const value = {
    productosCarrito,
    tipoEntrega,
    agregarProducto,
    eliminarProducto,
    cambiarCantidad,
    cambiarTipoEntrega,
    limpiarCarrito,
    calcularSubtotal,
    calcularCostoEnvio,
    calcularTotal,
  };

  return (
    <CarritoContext.Provider value={value}>
      {children}
    </CarritoContext.Provider>
  );
};
